import { LOCAL_LANGUAGE } from '@/constants/storageKey';
import { mq } from '@/utils/mediaQuery';

const { Link } = require('react-router-dom');
const { default: styled } = require('@emotion/styled');

/* ---------------------------------------------
웹사이트 공통 코드 (인쿼리에는 필요한 만큼만 정의해서 사용)
--------------------------------------------- */
export const isJapanese = localStorage.getItem(LOCAL_LANGUAGE) === 'ja';
const footerLogoZIndex = 600;
const CommonTitleFive = styled.div(({ theme, Black }) => ({
  lineHeight: isJapanese ? 1.5 : 1.4,
  fontFamily: theme.fontFamily.primaryFont,
  fontWeight: Black ? theme.fontWeight.Black : theme.fontWeight.bold,
  fontSize: '1.6rem',

  [mq('desktop')]: {
    fontSize: isJapanese ? '1.8rem' : '2rem',
  },
}));

/* ---------------------------------------------
푸터 (인쿼리에는 필요한 만큼만 정의해서 사용)
--------------------------------------------- */
export const FooterContainer = styled.footer(({ theme, noMargin }) => ({
  position: 'relative',
  height: '100%',
  marginTop: noMargin ? 0 : '10rem',
  fontFamily: theme.fontFamily.primaryFont,
  backgroundColor: '#E4E2DF',
  backgroundImage: `url(${theme.image.footerBackgroundMobile})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: '115% 100%',
  fontWeight: theme.fontWeight.regular,
  fontSize: '1.4rem',
  lineHeight: '1.5em',
  zIndex: 100,

  [mq('tablet')]: {
    backgroundSize: '100% auto',
  },

  [mq('desktop')]: {
    marginTop: noMargin ? 0 : '16rem',
    backgroundImage: `url(${theme.image.footerBackground})`,
    padding: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: theme.color.primary_color,
  },
}));

export const FooterTop = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',
  paddingBottom: '3rem',

  [mq('desktop')]: {
    gap: '0 6rem',
    flexDirection: 'row',
    paddingBottom: 0,
  },
}));

export const FooterTopLeft = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '80%',
  margin: '0 auto',

  [mq('desktop')]: {
    gap: '4rem 0',
    maxWidth: '100%',
    margin: 0,
  },
}));

export const FooterLogoWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  zIndex: footerLogoZIndex,
  margin: '5rem 0',

  [mq('desktop')]: {
    padding: '4rem',
    height: '100%',
    margin: 0,
  },
}));

export const FooterLogo = styled.object(() => ({
  width: '100%',
  maxWidth: '20rem',

  [mq('desktop')]: {
    width: '25rem',
    justifyContent: 'flex-end',
  },
}));

export const Address = styled.address(({ theme }) => ({
  marginBottom: '1.8rem',
  fontStyle: 'normal',
  lineHeight: 1.2,
  fontWeight: theme.fontWeight.bold,

  '& p + p': {
    margin: 0,
  },
}));

export const MenuWrapper = styled.div(() => ({
  marginBottom: '1rem',
  fontSize: '1.4rem',
  lineHeight: '1.5em',
}));

export const MenuTitle = styled.a(({ theme }) => ({
  display: 'block',
  marginBottom: '3rem',
  fontWeight: theme.fontWeight.bold,
  fontSize: isJapanese ? '1.8rem' : '2rem',
}));

export const FooterLink = styled.a(({ theme, bold }) => ({
  fontWeight: bold === 'true' ? theme.fontWeight.bold : theme.fontWeight.regular,
}));

export const FooterNav = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem 0',
  maxWidth: '20rem',
  margin: '0 auto',

  '& a:hover': {
    textDecoration: 'underline',
  },

  [mq('desktop')]: {
    margin: 0,
  },
}));

export const UnauthorizedCollectionOfEmail = styled.button(() => ({
  textAlign: 'left',
}));

export const FooterTopRight = styled.div(() => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: '2rem 0',

  '& section': {
    width: '100%',
  },

  '& section.center': {
    marginTop: 0,
  },

  [mq('desktop')]: {
    padding: '4rem 0',
    justifyContent: 'space-between',
    flexDirection: 'row',
    textAlign: 'left',
    alignItems: 'flex-start',

    '& section.center': {
      marginTop: '5.4rem',
    },
  },
}));

export const FooterMiddle = styled.div(({ theme }) => ({
  width: '100%',
  padding: '3rem 0',
  marginTop: '3rem',
  borderTop: `2px solid ${theme.color.light_grey}`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '4rem',

  [mq('desktop')]: {
    marginTop: '5rem',
    padding: '4rem 0',
  },
}));

export const FooterMiddleRow = styled.div(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1.5rem 5rem',
}));

export const FooterMiddleLink = styled(Link)(({ theme, bold }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  fontSize: '1.4rem',
  color: '#333',
  fontWeight: bold === 'true' ? theme.fontWeight.bold : theme.fontWeight.regular,

  '&:hover': {
    textDecoration: 'underline',
  },

  '&:not(:last-child)::after': {
    content: '""',
    position: 'absolute',
    // 부모의 gap(5rem)의 절반 위치인 -2.5rem에 구분선을 배치하여 완벽한 중앙을 맞춤
    right: '-2.5rem',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '1px',
    height: '1.4rem',
    backgroundColor: '#999',
  },
}));

export const FooterHotelSection = styled.section(() => ({
  maxWidth: '36rem',
}));

export const SectionHeader = styled(CommonTitleFive)(({ theme }) => ({
  fontWeight: theme.fontWeight.bold,
  marginBottom: '3rem',
}));

export const ContactList = styled.ul(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem 0',
}));

export const ContactItem = styled.li(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '0 1.4rem',
  flexWrap: 'wrap',
}));

export const FooterBusinessNumber = styled.div(() => ({
  marginTop: '5rem',
}));

export const FooterBottom = styled.div(({ theme, hasEventFooter }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: '3rem 0',
  paddingTop: '1.6rem',
  paddingBottom: '1.6rem',
  background: theme.color.white,
  fontSize: '1.2rem',
  marginBottom: hasEventFooter ? '6.8rem' : 0,

  [mq('desktop')]: {
    flexDirection: 'row',
    gap: '0 14rem',
  },
}));

export const FooterBottomWrapper = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column-reverse',
  alignItems: 'center',
  justifyContent: 'space-between',

  [mq('mobile')]: {
    gap: '1rem 0',
  },

  [mq('desktop')]: {
    gap: '4rem 0',
    flexDirection: 'row',
  },
}));

export const SnsWrapper = styled.section(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1rem 0',
  textTransform: 'uppercase',

  [mq('desktop')]: {
    gap: '0 3rem',
    flexDirection: 'row',
  },
}));

export const LinkGroup = styled.ul(() => ({
  display: 'flex',
  gap: '1rem 3rem',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',

  [mq('desktop')]: {
    gap: '0 2rem',
    flexWrap: 'nowrap',
  },

  a: {
    display: 'block',
  },

  object: {
    height: '3rem',
    pointerEvents: 'none',
  },
}));

export const CopyRight = styled.div(() => ({
  textAlign: 'center',

  [mq('desktop')]: {
    textAlign: 'left',
  },
}));

export const EventFooterWrapper = styled.footer({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  height: '6.8rem',
  padding: '1.2rem 0',
  backgroundColor: '#000',
  zIndex: 1000,

  [mq('tablet')]: {
    display: 'none',
  },
});

export const EventFooterContent = styled.div({
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  maxWidth: '768px',
  margin: '0 auto',
});

export const EventFooterItem = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.4rem',
  cursor: 'pointer',
  flex: 1,
  position: 'relative',
});

export const EventIconWrapper = styled.div({
  width: '2.4rem',
  height: '2.4rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
});

export const EventIcon = styled.img({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
});

export const EventLabel = styled.span({
  fontSize: '1.3rem',
  fontWeight: 'bold',
  color: '#fff',
});
